import {
  ClientSpecialistContractStatusEnum,
  ContractStatusEnum,
  FilterItem,
  FilterValue,
  Sort,
  Specialist,
} from '@mindly/ui-components';

export type SpecialistEducation = {
  institution_name: string;
  institution_logo_link: string | null;
  certificate_link: string | null;
  faculty: string | null;
  year_start: number | null;
  year_end: number | null;
};

/**
 * @deprecated use SupportedCurrency from @mindly/ui-components
 */
export enum SupportedCurrencies {
  'UAH' = 'UAH',
  'EUR' = 'EUR',
  'PLN' = 'PLN',
  'USD' = 'USD',
}

/**
 * @deprecated use StripeSupportedCurrency from @mindly/ui-components
 */
export const StripeSupportedCurrency = [SupportedCurrencies.EUR, SupportedCurrencies.PLN, SupportedCurrencies.USD];

/**
 * @deprecated use Specialist from @mindly/ui-components
 */
export interface ISpecialist {
  id: string;
  slug: string;
  first_name: string;
  last_name: string;
  specialization: string | null;
  session_price_uah: number;
  session_price: number;
  session_price_type: SupportedCurrencies;
  session_duration_minutes: number;
  video_link: string | null;
  video_cover_link: string;
  video_duration_seconds: number;
  super_specialist: boolean;
  reviews_average_rating: number;
  reviews_count: number;
  profile_lang: string;
  summary: string;
  years_of_experience: number;
  hours_of_practice: number | null;
  specialist_list_photo_link: string | null;
  is_active: boolean;
  is_public?: boolean;
  is_disabled?: boolean;
  full_name_in_instrumental_case: string;
  profile_photo_link: string | null;
  video_calling_photo_link: string | null;
  about: string | null;
  areas_of_work: Array<string> | [];
  areas_of_work_by_client_problem: Array<string> | [];
  localized_areas_of_work_by_client_problem: Array<string> | [];
  therapy_description: string | null;
  avatar_link: string | null;
  time_zone: string;
  mindly_contract_status?: ContractStatusEnum | null;
  client?: {
    specialist_client_contract_id?: string | null;
    specialist_client_contract_status?: ClientSpecialistContractStatusEnum | null;
  };
  education:
    | {
        institution_name: string;
        institution_logo_link: string | null;
        certificate_link: string | null;
        faculty: string | null;
        year_start: number | null;
        year_end: number | null;
      }[]
    | [];
  sex: 'male' | 'female';
  active_clients?: number | null;
  sessions_count?: number | null;
  country_of_birthday?: string;
  languages: Array<string> | [];
  year_of_birthday?: number;
  reviews_count_by_stars: { [key: string]: number };
  percent_match?: number;
  session_count_by_3_days?: number;
  favourite?: boolean;
  app_lang: string;
}

export type SpecialistStore = {
  listData: ISpecialist[] | null;
  loading: 'idle' | 'pending' | 'force-pending' | 'succeeded' | 'failed';
  limit: number;
  offset: number;
  isPaginationDisabled: boolean;
  total?: number;
  filters: {
    items: FilterItem[];
    values: Record<string, FilterValue>;
    loading: 'idle' | 'pending' | 'succeeded' | 'failed';
    totalItems?: number;
  };
  sort: Sort;
  goals: string[];
  backup: {
    listData: Specialist[];
    loading: 'idle' | 'pending' | 'succeeded' | 'failed';
  };
};
